/* eslint:disable */
/* tslint:disable */
// @ts-ignore
import Vue from "vue";
import App from "./App.vue";
import router from "@/router/router";
import store from "@/store/store";
import VueI18n from "vue-i18n";
import en from "@/i18n";

import VueHighlightJS from "vue-highlightjs";
import HighchartsVue from "highcharts-vue";

import NavblueUI from "@navblue/navblue-ui";
import "@navblue/navblue-ui-style/css/index.css"; // Import CSS
import "@navblue/navblue-ui-style/css/occ.css"; // Import CSS
import "@navblue/navblue-ui-style/css/globals.css"; // Import CSS
import "@/css/index.pcss";

import "@fortawesome/fontawesome-free/css/all.css";
import "@fortawesome/fontawesome-free/js/all.js";

import "highlight.js/styles/tomorrow-night-blue.css";

const PortalVue = require("portal-vue");

var key: any;
var value: any;

Vue.use(VueI18n);
Vue.use(NavblueUI);
Vue.use(PortalVue);

Vue.use(VueHighlightJS);
Vue.use(HighchartsVue);

const i18n: any = new VueI18n({
  locale: "en",
  fallbackLocale: "en",
  messages: en,
  silentTranslationWarn: true
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
